import type { Iti } from 'intl-tel-input';
import { resolveKeycloakUsername } from '../../core/utils/auth.utils';

import {
  PHONE_INPUT_DEFAULT_DIAL_CODE,
  PHONE_INPUT_INITIAL_COUNTRY,
} from '../config/phone-input.config';

export function getDialCodeFromIntlInput(instance?: Iti): string {
  const country = instance?.getSelectedCountry();
  return country?.dialCode ? `+${country.dialCode}` : PHONE_INPUT_DEFAULT_DIAL_CODE;
}

export function resolvePhoneCredentials(
  phone: string,
  instance?: Iti
): { username: string; dialCode: string } {
  const dialCode = getDialCodeFromIntlInput(instance);
  return {
    dialCode,
    username: resolveKeycloakUsername(phone, dialCode),
  };
}

/** Chiffres du numéro national, sans indicatif. */
export function toNationalPhone(phone: string, dialCode = ''): string {
  return resolveKeycloakUsername(phone, dialCode);
}

/**
 * Téléphone policies comme le mobile : indicatif (sans +) + numéro national.
 * Ex. 225 + 07000000 → 22507000000
 */
export function toPolicyPhoneNumber(phone: string, dialCode = ''): string {
  const national = toNationalPhone(phone, dialCode);
  const dial = (dialCode || '').replace(/\D/g, '');
  if (!national) {
    return '';
  }
  if (dial && national.startsWith(dial)) {
    return national;
  }
  return dial ? `${dial}${national}` : national;
}

export function getPhoneValidationError(errorCode: string | null | undefined): string {
  switch (errorCode) {
    case 'TOO_SHORT':
      return 'Numéro trop court.';
    case 'TOO_LONG':
      return 'Numéro trop long.';
    case 'INVALID_COUNTRY_CODE':
      return 'Indicatif pays invalide.';
    case 'INVALID_LENGTH':
    case 'IS_POSSIBLE_LOCAL_ONLY':
      return 'Numéro invalide pour ce pays.';
    default:
      return 'Numéro de téléphone invalide.';
  }
}
